import { api_get, api_post } from '@lf/api-client/lfApi';

export async function getVideoQnA(videoId, studyPlanId, setError) {
  return await api_get(
    '/video/qna',
    {
      vid: videoId,
      study_plan_id: studyPlanId,
    },
    setError,
    60000, // QnA takes a while to generate
  );
}

export async function getVideoQuestion(videoId, setError) {
  return await api_get(
    '/video/question',
    {
      vid: videoId,
    },
    setError,
  );
}

export async function updateVideoProgress(videoId, channelId, studyPlanId, lessonId, topicId, progress, setError) {
  return api_post(
    '/video/progress',
    {
      vid: videoId,
      channel_id: channelId,
      study_plan_id: studyPlanId,
      lesson_id: lessonId,
      topic_id: topicId,
      progress: progress,
    },
    setError,
  );
}

export async function getTimedTakeaways(videoId, channelId, studyPlanId, lessonId, topicId, setError) {
  return api_get(
    '/video/timed_takeaways',
    {
      vid: videoId,
      channel_id: channelId,
      study_plan_id: studyPlanId,
      lesson_id: lessonId,
      topic_id: topicId,
    },
    setError,
    120000, // Timed takeaways takes a while to generate
  );
}
